import { getUuid } from './getUuid'

export const QUERY_ZETA_REVIEW_FORM = '.js-zetaReviewForm'
const CLASS_NAME_ZETA_FORM = 'zv-form'

export const renderZataReviewForm = async (
  element,
  { color, employeeId, reviewerName, imageUrl, itemName, itemGroupId, sku } = {}
) => {
  const elementsZetaReviewForm = element.querySelectorAll(
    QUERY_ZETA_REVIEW_FORM
  )
  if (!elementsZetaReviewForm.length) return

  if (reviewerName) {
    const elementReviewerNameInput = document.querySelector(
      '[name=reviewer-nickname]'
    )
    if (elementReviewerNameInput) elementReviewerNameInput.value = reviewerName
  }

  const uuid = await getUuid({ employeeId })
  const setAttributesFunctions = Array.from(elementsZetaReviewForm).map(
    async (elementZetaReviewForm) => {
      elementZetaReviewForm.dataset.userId = uuid
      if (color) elementZetaReviewForm.dataset.itemColor = color
      if (itemName) elementZetaReviewForm.dataset.itemName = itemName
      if (itemGroupId) elementZetaReviewForm.dataset.itemGroup = itemGroupId
      if (reviewerName)
        elementZetaReviewForm.dataset.reviewerName = reviewerName
      if (sku) elementZetaReviewForm.dataset.itemId = sku
      if (imageUrl) elementZetaReviewForm.dataset.itemImage = imageUrl
      elementZetaReviewForm.classList.add(CLASS_NAME_ZETA_FORM)
    }
  )
  await Promise.all(setAttributesFunctions)
  window.zvRenderReviewForm(element)
}

export const resetZetaReviewForm = () => {
  const elementsZetaForm = document.getElementsByClassName(CLASS_NAME_ZETA_FORM)
  Array.from(elementsZetaForm).forEach((elementZetaForm) => {
    elementZetaForm.innerHTML = ''
  })
}
